import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonNumberClass;
function JsonNumber() {
  if (JsonNumberClass === VOID) {
    class $ {
      constructor(value) {
        this.r4a_1 = value;
      }
      toString() {
        return this.r4a_1;
      }
    }
    initMetadataForClass($, 'JsonNumber');
    JsonNumberClass = $;
  }
  return JsonNumberClass;
}
//region block: exports
export {
  JsonNumber as JsonNumber2j5ykr5cbjkre,
};
//endregion

//# sourceMappingURL=JsonNumber.mjs.map
